import { IoMdClose } from "react-icons/io";
import { setAppError } from "../../../../store/userSlice";
import nodeinstance from "../../../../nodeInstance";
import { useState } from "react";
import { useDispatch } from "react-redux";

export default function ExcelUpload({
  excelPopUp,
  setExcelPopUp,
  setTrigger,
  trigger,
}) {
  const token = localStorage.getItem("nodeToken");
  const [file, setFile] = useState();
  const dispatch = useDispatch();
  const submitHandler = async (e, fileData) => {
    console.log("fileData......", fileData, file);
    e.preventDefault();
    // setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      //   formData.append("id",clProject && clProject[0]?.project_id)
      if (fileData) {
        const response = await nodeinstance.put(
          `/insurance-dependent/uploadVendorExcel`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        if (response.status === 200) {
          setTrigger(!trigger);
          setExcelPopUp(false);
          dispatch(
            setAppError({
              msg: "Successfully uploaded.",
              color: "success",
            })
          );
          //   setSummaryUpdate(!summaryUpdate)
        }
        console.log("success to be seen here......", response);
      }
    } catch (error) {
      //   setLoading(false);
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          excelPopUp ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setExcelPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <form onSubmit={(e) => submitHandler(e, file)} className="w-full">
            <div className="w-full flex flex-col gap-3 my-3 p-5">
              <div className="form-control w-full ">
                <label className="label">
                  <span className="label-text">Upload File</span>
                </label>
                <input
                  type="file"
                  className="file-input file-input-bordered w-full "
                  onChange={(e) => setFile(e.target.files[0])}
                  required
                  //   accept="application/xls, application/xlsx"
                  accept=".xls,.xlsx"
                />
              </div>
              <div
                className="flex gap-3 w-full justify-center"
                style={{ m: 2 }}
              >
                <button
                  className="p-2 bg-blue text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                  onClick={() => {
                    setExcelPopUp(false);
                  }}
                >
                  {" "}
                  <p>CANCEL</p>
                </button>

                <button
                  type="submit"
                  className="p-2 bg-red text-white rounded-md w-full max-w-sm m-2 my-4 flex gap-3 justify-center items-center"
                >
                  {" "}
                  <p>Submit</p>
                  {/* {loading ? <CgSpinner className="animate-spin" /> : ""} */}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
